import { axios, Response } from '../index'

const blockTherapistAccessById = (therapistId: string): Response<null> => {
  return axios.delete(`/v1/therapists/${therapistId}/profiles`)
}

export default blockTherapistAccessById
